import { withTimezoneLabel } from "@utils/datetime";

export enum ClientApplicationTableColumns {
  productName = "productName",
  isVisible = "isVisible",
  reviewState = "reviewState",
  managedBy = "managedBy",
  supportedBy = "supportedBy",
  usedBy = "usedBy",
  category = "category",
  vendorName = "vendorName",
  businessOwner = "businessOwner",
  createdAt = "createdAt",
  lastUsed = "lastUsed",
  updatedAt = "updatedAt",
  notes = "notes",
  notifications = "notifications",
  productDescription = "productDescription",
  vendorDescription = "vendorDescription",
}

export const CLIENT_APPLICATION_TABLE_COLUMN_LABELS: Record<
  ClientApplicationTableColumns,
  string
> = {
  [ClientApplicationTableColumns.productName]: "Application",
  [ClientApplicationTableColumns.isVisible]: "Visibility",
  [ClientApplicationTableColumns.reviewState]: "Review State",
  [ClientApplicationTableColumns.managedBy]: "Managed By",
  [ClientApplicationTableColumns.supportedBy]: "Supported By",
  [ClientApplicationTableColumns.usedBy]: "Number of users",
  [ClientApplicationTableColumns.category]: "Category",
  [ClientApplicationTableColumns.vendorName]: "Vendor",
  [ClientApplicationTableColumns.businessOwner]: "Business Owner",
  [ClientApplicationTableColumns.createdAt]: withTimezoneLabel("First discovered"),
  [ClientApplicationTableColumns.lastUsed]: withTimezoneLabel("Last used"),
  [ClientApplicationTableColumns.updatedAt]: withTimezoneLabel("Updated"),
  [ClientApplicationTableColumns.notes]: "Notes",
  [ClientApplicationTableColumns.notifications]: "Notifications",
  [ClientApplicationTableColumns.productDescription]: "Description",
  [ClientApplicationTableColumns.vendorDescription]: "Vendor Description",
};

export const DEFAULT_CLIENT_APPLICATION_TABLE_COLUMN_SETTINGS: Record<
  ClientApplicationTableColumns,
  boolean
> = {
  [ClientApplicationTableColumns.productName]: true,
  [ClientApplicationTableColumns.isVisible]: true,
  [ClientApplicationTableColumns.reviewState]: true,
  [ClientApplicationTableColumns.managedBy]: true,
  [ClientApplicationTableColumns.supportedBy]: true,
  [ClientApplicationTableColumns.usedBy]: true,
  [ClientApplicationTableColumns.category]: true,
  [ClientApplicationTableColumns.vendorName]: false,
  [ClientApplicationTableColumns.businessOwner]: false,
  [ClientApplicationTableColumns.createdAt]: true,
  [ClientApplicationTableColumns.lastUsed]: true,
  [ClientApplicationTableColumns.updatedAt]: false,
  [ClientApplicationTableColumns.notes]: false,
  [ClientApplicationTableColumns.notifications]: false,
  [ClientApplicationTableColumns.productDescription]: false,
  [ClientApplicationTableColumns.vendorDescription]: false,
};

export const DEFAULT_CLIENT_APPLICATION_TABLE_COLUMN_ORDER: ClientApplicationTableColumns[] =
  [
    ClientApplicationTableColumns.productName,
    ClientApplicationTableColumns.isVisible,
    ClientApplicationTableColumns.reviewState,
    ClientApplicationTableColumns.managedBy,
    ClientApplicationTableColumns.supportedBy,
    ClientApplicationTableColumns.usedBy,
    ClientApplicationTableColumns.category,
    ClientApplicationTableColumns.vendorName,
    ClientApplicationTableColumns.businessOwner,
    ClientApplicationTableColumns.createdAt,
    ClientApplicationTableColumns.lastUsed,
    ClientApplicationTableColumns.updatedAt,
    ClientApplicationTableColumns.notes,
    ClientApplicationTableColumns.notifications,
    ClientApplicationTableColumns.productDescription,
    ClientApplicationTableColumns.vendorDescription,
  ];

// Helper functions to generate derived data
export const getColumnLabels = (): Record<string, string> =>
  CLIENT_APPLICATION_TABLE_COLUMN_LABELS;
export const getDefaultColumnSettings = (): Record<string, boolean> =>
  DEFAULT_CLIENT_APPLICATION_TABLE_COLUMN_SETTINGS;
export const getDefaultColumnOrder = (): string[] =>
  DEFAULT_CLIENT_APPLICATION_TABLE_COLUMN_ORDER;
